import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import Input from 'Components/Input'
import Checkbox from 'Components/Checkbox';
import Dropdown from 'Components/Dropdown';
import { ReactComponent as PlusIcon } from 'Icons/plus.svg';
import { ReactComponent as TrashIcon } from 'Icons/trash.svg';
import { ReactComponent as CloseIcon } from 'Icons/close-circle.svg';
import Cx from 'classnames';

import PlacesAutoComplete from 'Components/PlacesAutoComplete';

import { LEGS_TYPES, DOOR_TO_DOOR_LEGS_TYPES, TAT_UNITS, COST_TYPE, LEGS_TYPES_AIR, LEGS_TYPES_SEA, HIKAL } from 'Constants/commonConstants';
import { getUser } from 'Utils/storage';
import ConfirmationPopup from 'Components/ConfirmationPopup';
import { GET_EXIM_LPP_DETAILS } from 'Constants/actionConstants';

class LegDetails extends Component {
   constructor(props) {
      super(props);
      this.trip = props.trip;
      this.viewMode = props.viewMode;
      this.legs = this.trip.legs;
      if(HIKAL.includes(getUser().companyId)) {
         const { rfq, rfqType } = this.props;
         if(rfqType === 5 && (this.legs || []).length > 0) {
            const isSea = ((rfq.rfqDetails || {}).serviceCategoryType === 1);
            const isLCL = ((rfq.rfqDetails || {}).serviceCategoryType === 1 && (rfq.rfqDetails || {}).serviceType === 5);
            const chargableWeight = ((this.trip.cargoParticularList || []).reduce((sum, el) => sum += Number(el.chargableWeight || 0),0));
            (this.legs || []).map((leg, index) => {
               if(((rfq.rfqDetails || {}).serviceCategoryType === 1 ? (rfq.rfqDetails || {}).serviceType === 5 : true)) {
                  this.legs[index].setBusinessVolumeUnit(this.trip.metricSystem === 1 ? (((rfq.rfqDetails || {}).serviceCategoryType === 1 && (rfq.rfqDetails || {}).serviceType === 5) ? { value: 11, name: "Per Cubic Meter"} : { value: 2, name: "Kilograms (KGs)"}) : { value: 12, name: "Pounds"});
                  this.legs[index].setBusinessVolumeValue(chargableWeight)
               } else if(isSea && (rfq.rfqDetails || {}).serviceType !== 5) {
                  this.legs[index].setBusinessVolumeUnit({ value: 8, name: "Container Load" });
                  this.legs[index].setBusinessVolumeValue((this.trip || {}).noOfContainers || 1);
               }
               (this.legs[index].multiModeHeadingCharges || []).map((hc, hcIndex) => {
                  if(((rfq.rfqDetails || {}).serviceCategoryType === 1 ? (rfq.rfqDetails || {}).serviceType === 5 : true)) {
                     this.legs[index].multiModeHeadingCharges[hcIndex].headingChargesBusinessVolumeValue =  (chargableWeight);
                     this.legs[index].multiModeHeadingCharges[hcIndex].headingChargesBusinessVolumeUnit = this.trip.metricSystem === 1 ? (isLCL ? 11 : 2) : 12;
                     this.legs[index].multiModeHeadingCharges[hcIndex].headingChargesBusinessVolumeUnitName = this.trip.metricSystem === 1 ? (isLCL ? "Per Cubic Meter" : "Kilograms (KGs)") : 'Pounds';
                  } else if(isSea && (rfq.rfqDetails || {}).serviceType !== 5) {
                     this.legs[index].multiModeHeadingCharges[hcIndex].headingChargesBusinessVolumeValue = (this.trip || {}).noOfContainers || 1;
                     this.legs[index].multiModeHeadingCharges[hcIndex].headingChargesBusinessVolumeUnit = 8;
                     this.legs[index].multiModeHeadingCharges[hcIndex].headingChargesBusinessVolumeUnitName = "Container Load";
                  }
               })
            })
         }
      }
      this.state = {
         trip: props.trip,
         legs: this.trip.legs,
         isConfirmPopUp: false,
      }
   }

   addNewHeadingCharge = (index) => {
      const { rfq } = this.props;
      this.legs[index].addNewMultiModeHeadingCharge({
         headingChargesValue: '',
         headingChargesUnit: '',
         headingChargesUnitName: '',
         headingChargesUnitSymbol: '',
         headingChargesDescription: '',
         headingChargesMr: '',
         headingChargesLpp: '',
         headingChargesBudget: '',
         headingChargesCp: ''
      }, this.props.rfqServiceType);
      if(this.legs[index].multiModeHeadingCharges.length === 1 && this.legs[index].multiModeHeadingCharges.length === 1 && this.props.costHeadList.length > 0 && HIKAL.includes(getUser().companyId) && this.props.rfqType === 5) {
         const isSea = ((rfq.rfqDetails || {}).serviceCategoryType === 1);
         const isLCL = ((rfq.rfqDetails || {}).serviceCategoryType === 1 && (rfq.rfqDetails || {}).serviceType === 5);
         const chargableWeight = ((this.state.trip.cargoParticularList || []).reduce((sum, el) => sum += Number(el.chargableWeight || 0),0));
         if(((rfq.rfqDetails || {}).serviceCategoryType === 1 ? (rfq.rfqDetails || {}).serviceType === 5 : true)) {
            this.legs[index].setBusinessVolumeUnit(this.state.trip.metricSystem === 1 ? (((rfq.rfqDetails || {}).serviceCategoryType === 1 && (rfq.rfqDetails || {}).serviceType === 5) ? { value: 11, name: "Per Cubic Meter"} : { value: 2, name: "Kilograms (KGs)"}) : { value: 12, name: "Pounds"});
            this.legs[index].setBusinessVolumeValue(chargableWeight)
         }
         this.legs[index].multiModeHeadingCharges[0].headingChargesValue = 'Base Freight';
         this.legs[index].multiModeHeadingCharges[0].isBaseFreight = true;
         if(((rfq.rfqDetails || {}).serviceCategoryType === 1 ? (rfq.rfqDetails || {}).serviceType === 5 : true)) {
            this.legs[index].multiModeHeadingCharges[0].headingChargesBusinessVolumeValue =  (chargableWeight);
            this.legs[index].multiModeHeadingCharges[0].headingChargesBusinessVolumeUnit = this.state.trip.metricSystem === 1 ? (isLCL ? 11 : 2) : 12;
            this.legs[index].multiModeHeadingCharges[0].headingChargesBusinessVolumeUnitName = this.state.trip.metricSystem === 1 ? (isLCL ? "Per Cubic Meter" : "Kilograms (KGs)") : 'Pounds';
         } else if(isSea && (rfq.rfqDetails || {}).serviceType !== 5) {
            this.legs[index].multiModeHeadingCharges[0].headingChargesBusinessVolumeValue =  (this.state.trip || {}).noOfContainers || 1;
            this.legs[index].multiModeHeadingCharges[0].headingChargesBusinessVolumeUnit = 8;
            this.legs[index].multiModeHeadingCharges[0].headingChargesBusinessVolumeUnitName = "Container Load";
         }
         (this.props.costHeadList || []).map(cost => {
            this.legs[index].addNewMultiModeHeadingCharge({
               headingChargesValue: cost.name,
               headingChargesUnit: '',
               headingChargesUnitName: '',
               headingChargesUnitSymbol: '',
               headingChargesDescription: '',
               headingChargesMr: '',
               headingChargesLpp: '',
               headingChargesBudget: '',
               headingChargesCp: '',
               headingChargesBusinessVolumeValue: isSea ? (isLCL ? chargableWeight : (this.state.trip || {}).noOfContainers || 1) : chargableWeight,
               headingChargesBusinessVolumeUnit: isSea ? (isLCL ? (this.state.trip.metricSystem === 1 ? 11 : 2) : 8) : (this.state.trip.metricSystem === 1 ? 2 : 12),
               headingChargesBusinessVolumeUnitName: isSea ? (isLCL ? (this.state.trip.metricSystem === 1 ? "Per Cubic Meter" : "Kilograms (KGs)") : "Container Load") : (this.state.trip.metricSystem === 1 ? "Kilograms (KGs)" : "Pounds")
            }, this.props.rfqServiceType, HIKAL.includes(getUser().companyId))
         })
      } else if(HIKAL.includes(getUser().companyId)) {
         const isSea = ((rfq.rfqDetails || {}).serviceCategoryType === 1);
         const isLCL = ((rfq.rfqDetails || {}).serviceCategoryType === 1 && (rfq.rfqDetails || {}).serviceType === 5);
         const chargableWeight = ((this.state.trip.cargoParticularList || []).reduce((sum, el) => sum += Number(el.chargableWeight || 0),0));
         const costHeadIndex = this.legs[index].multiModeHeadingCharges.length - 1;
         if(((rfq.rfqDetails || {}).serviceCategoryType === 1 ? (rfq.rfqDetails || {}).serviceType === 5 : true)) {
            this.legs[index].multiModeHeadingCharges[costHeadIndex].headingChargesBusinessVolumeValue =  (chargableWeight);
            this.legs[index].multiModeHeadingCharges[costHeadIndex].headingChargesBusinessVolumeUnit = this.state.trip.metricSystem === 1 ? (isLCL ? 11 : 2) : 12;
            this.legs[index].multiModeHeadingCharges[costHeadIndex].headingChargesBusinessVolumeUnitName = this.state.trip.metricSystem === 1 ? (isLCL ? "Per Cubic Meter" : "Kilograms (KGs)") : 'Pounds';
         } else if(isSea && (rfq.rfqDetails || {}).serviceType !== 5) {
            this.legs[index].multiModeHeadingCharges[costHeadIndex].headingChargesBusinessVolumeValue =  (this.state.trip || {}).noOfContainers || 1;
            this.legs[index].multiModeHeadingCharges[costHeadIndex].headingChargesBusinessVolumeUnit = 8;
            this.legs[index].multiModeHeadingCharges[costHeadIndex].headingChargesBusinessVolumeUnitName = "Container Load";
         }
      }
      this.setState({
         legs: this.legs
      })
   }

   handleMrCharges = (e) => {
      if (this.viewMode) {
         return;
      }
      const { trip } = this.state;
      trip.headingChargesMr = e.target.value;
      this.trip.setHeadingChargesMr(e.target.value)
      this.setState({ 
         trip: this.trip
      });
      this.props.onChange();
   }

   handleLppCharges = (e) => {
      if (this.viewMode) {
         return;
      }
      const { trip } = this.state;
      trip.headingChargesLpp = e.target.value;
      this.trip.setHeadingChargesLpp(e.target.value)
      this.setState({ 
         trip: this.trip
      });
      this.props.onChange();
   }

   handleTotalBudget = (e) => {
      if (this.viewMode) {
         return;
      }
      const { trip } = this.state;
      trip.totalBudget = e.target.value;
      this.trip.setTotalBudget(e.target.value)
      this.setState({ 
         trip: this.trip
      });
      this.props.onChange();
   }

   selectBaseCurrency = (option) => {
      if (this.viewMode) {
         return;
      }
      const { trip } = this.state;
      trip['priceInBaseCurrency'] = option.currency_name;
      trip['priceInBaseCurrencyType'] = option.currency_type;
      trip['priceInBaseCurrencySymbol'] = option.currency_symbol;
      if(HIKAL.includes(getUser().companyId)) {
         (this.legs || []).map((leg, legIndex) => {
            leg.selectCostType(option.currency_type, option.currency_name, option.currency_symbol);
            (leg.multiModeHeadingCharges || []).map((mHeadingCharges, mIndex) => {
               mHeadingCharges.headingChargesUnitName = option.currency_name;
               mHeadingCharges.headingChargesUnitSymbol = option.currency_symbol;
               mHeadingCharges.headingChargesUnit = option.currency_type;
            })
         });
         this.setState({
            legs: this.legs
         })
      }
      this.trip.setTotalBudget(option);
      this.setState({ 
         trip: this.trip
      });
      this.props.onChange();
   }

   setFromLocation = (index, location) => {
      if (this.viewMode) {
         return;
      }
      this.legs[index].setFromLocation(location);
      this.setState({
         legs: this.legs
      }, () => {
         this.getLPPDetails(index);
      });
      this.props.onChange();
   }

   setToLocation = (index, location) => {
      if (this.viewMode) {
         return;
      }
      this.legs[index].setToLocation(location);
      this.setState({
         legs: this.legs
      }, () => {
         this.getLPPDetails(index);
      });
      this.props.onChange();

   }
   addLeg = () => {
      if (this.viewMode) {
         return;
      }
      if(this.props.rfqType === 5) {
         this.props.trip.addLeg();
         const { rfq } = this.props;
         if(HIKAL.includes(getUser().companyId) && ((rfq.rfqDetails || {}).serviceCategoryType === 1 ? (rfq.rfqDetails || {}).serviceType === 5 : true)) {
            const legIndex = (this.legs.length - 1);
            this.legs[legIndex].setBusinessVolumeUnit(this.state.trip.metricSystem ? { value: 2, name: "Kilograms (KGs)"} : {value: 12, name: "Pounds"});
            this.legs[legIndex].setBusinessVolumeValue((this.state.trip.cargoParticularList || []).reduce((sum, el) => sum + Number(el.chargableWeight || 0),0));
         } else {
            this.props.trip.legs[this.props.trip.legs.length - 1].setBusinessVolumeUnit({ value: 8, name: "Container Load"});
            this.props.trip.legs[this.props.trip.legs.length - 1].setBusinessVolumeValue(this.state.trip.noOfContainers || 1);
         }
      } else {
         this.props.trip.addLeg();
      }
      this.setState({
         legs: this.props.trip.legs
      });
   }
   selectLegType = (index, legType, legTypeName) => {
      if (this.viewMode) {
         return;
      }
      this.legs[index].setLegType(legType, legTypeName);
      this.setState({
         legs: this.legs
      })
   }

   selectCostType = (index, legCostType, legCostName, legCostSymbol) => {
      if (this.viewMode) {
         return;
      }
      if (this.props.multiLevelMovementType !== 2) {
         this.legs[0].setLegType(1, "Door to Door")
      }
      this.legs[index].selectCostType(legCostType, legCostName, legCostSymbol);
      this.setState({
         legs: this.legs
      })
   }

   onChange = (index, e) => {
      if (this.viewMode) {
         return;
      }
      const name = e.target.name;
      const value = e.target.value;

      this.legs[index]['set' + name.substr(0, 1).toUpperCase() + name.slice(1)](value, this.props.rfqServiceType);
      this.setState({
         legs: this.legs
      });
   }

   onChangeBudget = (index, e) => {
      const { rfqType, currencyDetails, trip } = this.props;
      const currencyType = (this.legs[index].legCostName !== 'INR') ? this.legs[index].legCostName : trip.priceInBaseCurrency;
      const conversionUSDObj = currencyDetails.find(currencyObj => currencyObj.name === (currencyType === 'EUR' ? 'EUR to INR' : 'USD to INR'));
      if (this.viewMode) {
         return;
      }
      const { value, name } = e.target;
      if(rfqType === 5 && name === 'legBudgetINR') {
         this.legs[index].setBudget(value);
         this.legs[index].setBudgetINR(value);
         this.legs[index].setBudgetUSD( value && conversionUSDObj && ((value / conversionUSDObj.rupee).toFixed(5)) || value, currencyType === 'EUR');
      } else if(rfqType === 5 && (['legBudgetUSD', 'legBudgetSecondary'].includes(name))) {
         this.legs[index].setBudget(value && conversionUSDObj && ((value * conversionUSDObj.rupee).toFixed(5)) || value);
         this.legs[index].setBudgetINR(value && conversionUSDObj && ((value * conversionUSDObj.rupee).toFixed(5)) || value);
         this.legs[index].setBudgetUSD(value, currencyType === 'EUR');
      } else {
         this.legs[index].setBudget(value);
      }
      this.setState({
         legs: this.legs
      });
   }

   onChangeBudgetCP = (index, e) => {
      const { rfqType, currencyDetails, trip, rfqServiceType} = this.props;
      const currencyType = (this.legs[index].legCostName !== 'INR') ? this.legs[index].legCostName : trip.priceInBaseCurrency;;
      const conversionUSDObj = currencyDetails.find(currencyObj => currencyObj.name === (currencyType === 'EUR' ? 'EUR to INR' : 'USD to INR'));
      if (this.viewMode) {
         return;
      }
      const { value, name } = e.target;
      if(rfqType === 5 && name === 'legBudgetCPINR') {
         this.legs[index].setBudgetCP(value, rfqServiceType);
         this.legs[index].setBudgetCPINR(value, rfqServiceType);
         this.legs[index].setBudgetCPUSD( value && conversionUSDObj && ((value / conversionUSDObj.rupee).toFixed(5)) || value, currencyType === 'EUR', rfqServiceType);
      } else if(rfqType === 5 && ['legBudgetCPUSD', 'legBudgetCPSecondary'].includes(name)) {
         this.legs[index].setBudgetCP(value && conversionUSDObj && ((value * conversionUSDObj.rupee).toFixed(5)) || value, rfqServiceType);
         this.legs[index].setBudgetCPINR(value && conversionUSDObj && ((value * conversionUSDObj.rupee).toFixed(5)) || value, rfqServiceType);
         this.legs[index].setBudgetCPUSD(value, currencyType === 'EUR', rfqServiceType);
      } else {
         this.legs[index].setBudgetCP(value);
      }
      this.setState({
         legs: this.legs
      });
   }

   onSelect = (index, value, name) => {
      if (this.viewMode) {
         return;
      }

      if(value.name ==="Select days/hrs"){
         alert("Please select Day or Hours");
         return
      }

      this.legs[index]['set' + name.substr(0, 1).toUpperCase() + name.slice(1)](value);
      this.setState({
         legs: this.legs
      });
   }

   onHCChange = (index, hcIndex, value, name, option = {}) => {
      const { rfqType, currencyDetails, trip, rfqServiceType } = this.props;
      let newHeadingCharge = this.legs[index]['multiModeHeadingCharges'];
      const legCurrencyType = newHeadingCharge[hcIndex].headingChargesUnitName;
      const currencyType = (legCurrencyType === "INR" ||  !legCurrencyType) ? ((this.legs[index].legCostName === 'INR' || !this.legs[index].legCostName) ? trip.priceInBaseCurrency : this.legs[index].legCostName ) : legCurrencyType;
      const conversionUSDObj = currencyDetails.find(currencyObj => currencyObj.name === (currencyType === 'EUR' ? 'EUR to INR' : 'USD to INR'));
      const isHikal = HIKAL.includes(getUser().companyId);
      if (this.viewMode) {
         return;
      }
      newHeadingCharge[hcIndex][name] = value;
      if(rfqType === 5 && name === 'headingChargesUnit') {
         newHeadingCharge[hcIndex]['headingChargesUnitName'] = option.currency_name;
         newHeadingCharge[hcIndex]['headingChargesUnitSymbol'] = option.currency_symbol;
      }
      if(rfqType === 5 && (name === 'headingChargesBudget_inr' || name === 'headingChargesCp_inr')) {
         newHeadingCharge[hcIndex][name === 'headingChargesCp_inr' ? 'headingChargesCp' : 'headingChargesBudget'] = value;
         newHeadingCharge[hcIndex][name === 'headingChargesCp_inr' ? (currencyType === 'EUR' ? 'headingChargesCp_secondary' :'headingChargesCp_usd') : (currencyType === 'EUR' ? 'headingChargesBudget_secondary' :'headingChargesBudget_usd')] = value && conversionUSDObj && (value / conversionUSDObj.rupee).toFixed(5) || value;

      } else if(rfqType === 5 && (['headingChargesBudget_usd','headingChargesBudget_secondary','headingChargesCp_secondary','headingChargesCp_usd'].includes(name))) {
         newHeadingCharge[hcIndex][['headingChargesCp_usd', 'headingChargesCp_secondary'].includes(name) ? 'headingChargesCp' : 'headingChargesBudget'] = value && conversionUSDObj && (value * conversionUSDObj.rupee).toFixed(5) || value;
         newHeadingCharge[hcIndex][['headingChargesCp_usd', 'headingChargesCp_secondary'].includes(name) ? 'headingChargesCp_inr' : 'headingChargesBudget_inr'] = value && conversionUSDObj && (value * conversionUSDObj.rupee).toFixed(5) || value;
      } else if(rfqType === 5 && (HIKAL.includes(getUser().companyId) ? true : rfqServiceType === 5) && name === 'headingChargesBusinessVolumeUnit') {
         newHeadingCharge[hcIndex]['headingChargesBusinessVolumeUnitName'] = option.name;
      }
      if(rfqType === 5 && (HIKAL.includes(getUser().companyId) ? true :rfqServiceType === 5)) {
         const headingCost = newHeadingCharge[hcIndex];
         const businessVolume = Number(headingCost['headingChargesBusinessVolumeValue'] || 0);
         if(businessVolume) {
            newHeadingCharge[hcIndex]['headingChargeVolumeCp_inr'] = headingCost['headingChargesCp_inr'] && (Number(headingCost['headingChargesCp_inr']) * businessVolume) || 0;
            newHeadingCharge[hcIndex]['headingChargeVolumeCp_usd'] = headingCost['headingChargesCp_usd'] && (Number(headingCost['headingChargesCp_usd']) * businessVolume) || 0;
            newHeadingCharge[hcIndex]['headingChargesVolumeCp_secondary'] = headingCost['headingChargesCp_secondary'] && (Number(headingCost['headingChargesCp_secondary']) * businessVolume) || 0;
         }
      }
      this.legs[index]['multiModeHeadingCharges'] = newHeadingCharge;
      this.legs[index].updateMultiModeHeadingCharge(newHeadingCharge);
      if(newHeadingCharge[hcIndex]['headingChargesValue'] === 'Base Freight' && HIKAL.includes(getUser().companyId)) {
         const hcCharges = newHeadingCharge[hcIndex];
         if(name === 'headingChargesCp_inr') {
            value = (value * (hcCharges['headingChargesBusinessVolumeUnit'] == 20 ? 1 : hcCharges['headingChargesBusinessVolumeValue']));
            this.legs[index].setBudgetCP(value, rfqServiceType);
            this.legs[index].setBudgetCPINR(value, rfqServiceType);
            this.legs[index].setBudgetCPUSD( value && conversionUSDObj && ((value / conversionUSDObj.rupee).toFixed(5)) || value, currencyType === 'EUR', rfqServiceType);
         } else if(name === 'headingChargesBudget_inr') {
            this.legs[index].setBudget(value);
            this.legs[index].setBudgetINR(value);
            this.legs[index].setBudgetUSD( value && conversionUSDObj && ((value / conversionUSDObj.rupee).toFixed(5)) || value, currencyType === 'EUR');
         }else if(['headingChargesCp_secondary', 'headingChargesCp_usd'].includes(name)) {
            value = (value * (hcCharges['headingChargesBusinessVolumeUnit'] == 20 ? 1 : hcCharges['headingChargesBusinessVolumeValue']));
            this.legs[index].setBudgetCP(value && conversionUSDObj && ((value * conversionUSDObj.rupee).toFixed(5)) || value, rfqServiceType);
            this.legs[index].setBudgetCPINR(value && conversionUSDObj && ((value * conversionUSDObj.rupee).toFixed(5)) || value, rfqServiceType);
            this.legs[index].setBudgetCPUSD(value, currencyType === 'EUR', rfqServiceType);
         } else if(['headingChargesBudget_usd', 'headingChargesBudget_secondary'].includes(name)) {
            this.legs[index].setBudget(value && conversionUSDObj && ((value * conversionUSDObj.rupee).toFixed(5)) || value);
            this.legs[index].setBudgetINR(value && conversionUSDObj && ((value * conversionUSDObj.rupee).toFixed(5)) || value);
            this.legs[index].setBudgetUSD(value, currencyType === 'EUR');
         }  else if(name === 'headingChargesBusinessVolumeValue') {
            this.legs[index].setBusinessVolumeValue(value);
            const price = (hcCharges['headingChargesCp_inr'] * (hcCharges['headingChargesBusinessVolumeUnit'] == 20 ? 1 : hcCharges['headingChargesBusinessVolumeValue']));
            this.legs[index].setBudgetCP(price, rfqServiceType);
            this.legs[index].setBudgetCPINR(price, rfqServiceType);
            this.legs[index].setBudgetCPUSD(price && conversionUSDObj && ((price / conversionUSDObj.rupee).toFixed(5)) || price, currencyType === 'EUR', rfqServiceType);
         } else if(name === 'headingChargesBusinessVolumeUnit') {
            this.legs[index].setBusinessVolumeUnit(option);
            const price = (hcCharges['headingChargesCp_inr'] * (hcCharges['headingChargesBusinessVolumeUnit'] == 20 ? 1 : hcCharges['headingChargesBusinessVolumeValue']));
            this.legs[index].setBudgetCP(price, rfqServiceType);
            this.legs[index].setBudgetCPINR(price, rfqServiceType);
            this.legs[index].setBudgetCPUSD(price && conversionUSDObj && ((price / conversionUSDObj.rupee).toFixed(5)) || price, currencyType === 'EUR', rfqServiceType);
         } else if(name === 'headingChargesUnit') {
            this.legs[index].selectCostType(option.currency_type, option.currency_name, option.currency_symbol);
         }
      }
      this.setState({
         legs: this.legs,
         isConfirmPopUp: false,
         legCurrencyDetails: ''
      });
   }

   removeMultiModeHeadingCharge = (index, hcIndex) => {
      let newHeadingCharge = this.legs[index]['multiModeHeadingCharges']
      newHeadingCharge = newHeadingCharge.filter((item, index) => index !== hcIndex);
      this.legs[index]['multiModeHeadingCharges'] = newHeadingCharge;
      this.legs[index].updateMultiModeHeadingCharge(newHeadingCharge);
      this.setState({
         legs: this.legs
      });
   }

   removeLeg = (index) => {
      if (this.viewMode) {
         return;
      }
      this.trip.removeLeg(index);
      this.setState({
         legs: this.trip.legs
      });
   }
   checkLegExists = (arr, value) => {
      const found = arr.some(el => el.legType === value);
      if (!found)
         return true;
      return false;
   }

   getLPPDetails = (index) => {
      const { legs } = this.state;
      const legDetails = legs[index];
      const isHikal = HIKAL.includes(getUser().companyId);
      if(isHikal && (legDetails.from || {}).location && (legDetails.to || {}).location) {
         const { dispatch } = this.props;
         dispatch({
            type: GET_EXIM_LPP_DETAILS,
            data: {
               from: (legDetails.from || {}).location,
               to: (legDetails.to || {}).location,
               legType: legDetails.legType,
               costHeadingList: (legDetails['multiModeHeadingCharges'] || []).map(el => el['headingChargesValue'])
            },
            onSuccess: (data) => {
               if(data && (data.multi_mode_heading_challenge_price || []).length > 0) {
                  let newHeadingCharge = this.legs[index]['multiModeHeadingCharges'];
                  (newHeadingCharge || []).forEach(el => {
                        const lppData = (data.multi_mode_heading_challenge_price || []).find(mCharge => (el.headingChargesValue || '').toLowerCase() == (mCharge.headingChargesValue || '').toLowerCase());
                        if(lppData) {
                           el.headingChargesLpp_inr = lppData.lpp_inr;
                           el.headingChargesLpp_usd = lppData.lpp_usd;
                           el.headingChargesLpp_secondary = lppData.lpp_secondary;
                        }
                  });
                  this.legs[index]['multiModeHeadingCharges'] = newHeadingCharge;
                  this.setState({
                     legs: this.legs
                  });
               }
            }
         });
      }
   }

   render() {
      const { legs, legCurrencyDetails } = this.state;
      const {
         trip,
         businessVolumes,
         pricingBasis,
         multiLevelMovementType,
         rfqType,
         stopDetailsSubmitted,
         currencyTypes,
         rfqServiceType,
         baseCurrencySubmitted,
         rfq,
         costHeadList
      } = this.props;
      const isHikal = HIKAL.includes(getUser().companyId);
      const baseCurrencyTypes = currencyTypes || (currencyTypes || []).filter(ct => ct.currency_name !== 'INR');

      return (
         <React.Fragment>
				<div className={Cx("flex flex-center mb-10", {'mt--30': !(isHikal && rfq.type === 5), 'mt-10': (isHikal && rfq.type === 5)})}>
               {rfqType === 5 ?
               <div className="mr-20 flex mb-5 input-height">
              <sup class="danger-color ml-2 pr t-4">*</sup><label className="fSemibold mt-8 mr-5">Base Currency</label> 
                  <Dropdown
                     items={baseCurrencyTypes}
                     selectedItem={baseCurrencyTypes.find(costType => { return trip.priceInBaseCurrencyType === costType['currency_type'] })}
                     name="currency_name"
                     onSelect={this.selectBaseCurrency}
                     displayKey="currency_name"
                     className="flex-1 fs-14 wt-150"
                     label="Select"
                  />
               </div> :
               <Fragment>
                  <div className="mr-20 flex mb-5 input-height">
                     <label className="fSemibold mt-8 mr-5">RR:</label> 
                     <Input className={'border-bottom-light wt-100 handling-charges-ip'} value={trip.headingChargesMr} onChange={(e) => this.handleMrCharges(e)} type="number" placeholder="RR" name="headingChargesMr" />
                  </div>
                  <div className="mr-20 flex mb-5 input-height">
                     <label className="fSemibold mt-8 mr-5">LPP:</label> 
                     <Input className={'border-bottom-light wt-100 handling-charges-ip'} value={trip.headingChargesLpp} onChange={(e) => this.handleLppCharges(e)} type="number" placeholder="LPP" name="headingChargesLpp" />
                  </div>
                  <div className="mr-20 flex mb-5 input-height">
                     <label className="fSemibold mt-8 mr-5">Budget:</label> 
                     <Input className={'border-bottom-light wt-100 handling-charges-ip'} value={trip.totalBudget} onChange={(e) => this.handleTotalBudget(e)} type="number" placeholder="Budget" name="headingChargesBudget" />
                  </div>
               </Fragment>}
               {rfqType === 5  && baseCurrencySubmitted && !trip.priceInBaseCurrency && <span className ="error-color fs-14 fSemibold op-7 mt-10">Please Select the Base Currency</span> }
            </div>
              {
               legs.map((leg, index) => {
                   leg.legType=(multiLevelMovementType==1)?1:leg.legType;
                   leg.legTypeName=(multiLevelMovementType==1)?"Door to Door":leg.legTypeName;
                   const secondaryCurrency = (leg.legCostName === 'INR' || !leg.legCostName) ? trip.priceInBaseCurrency : leg.legCostName; 
                   const isDiffMultiLegCurrency = (leg.multiModeHeadingCharges || []).filter(mc => (mc.headingChargesUnitName && mc.headingChargesUnitName !== 'INR')).length > 0;
                  return (

                     <div key={leg.id} className="border-status-bar br-5 pl-10 pr-10 pt-20 pb-20 mb-20 pr">
                        {legs.length > 1 && <CloseIcon className="pa t--15 r--15 curP" onClick={this.removeLeg.bind(this, index)} />}
                        {multiLevelMovementType === 2 ? <div className="header-medium-color fBold fs-20 mb-10">Leg {index + 1}</div> : <div className="header-medium-color fBold fs-20 mb-10">Door To Door</div>}
                        <div className="flex flex-between mb-10">
                           <div className="col-2 mr-20">
                              <div className="fSemibold fs-14 header-medium-color mb-5 ml-5">From</div>
                              {!this.viewMode && <PlacesAutoComplete hasError={stopDetailsSubmitted && !leg.from.location} setLocation={this.setFromLocation.bind(this, index)} value={leg.from.location || ''} />}
                              {this.viewMode && <Input value={leg.from.location || ''} />}
                           </div>
                           <div className="col-2">
                              <div className="fSemibold fs-14 header-medium-color mb-5 ml-5">To</div>
                              {!this.viewMode && <PlacesAutoComplete hasError={stopDetailsSubmitted && !leg.to.location} setLocation={this.setToLocation.bind(this, index)} value={leg.to.location || ''} />}
                              {this.viewMode && <Input value={leg.to.location || ''} />}
                           </div>
                        </div>
                        <div className="flex mb-40">
                           <div className={Cx("mr-10", {
                              'wt-110': !isHikal,
                              'wt-180': isHikal
                           })}>
                              <div className="fBold fs-14 header-medium-color mb-5 ml-5 ht-20">Leg Type</div>
                              {multiLevelMovementType === 2 ? <Dropdown
                                 items={((rfq.type === 5 && isHikal) ? ((rfq.rfqDetails || {}).serviceCategoryType === 1 ? [...LEGS_TYPES_SEA] : [...LEGS_TYPES_AIR]) : [...LEGS_TYPES]).filter(el => this.checkLegExists(legs, el.value))}
                                 selectedItem={((rfq.type === 5 && isHikal) ? ((rfq.rfqDetails || {}).serviceCategoryType === 1 ? [...LEGS_TYPES_SEA] : [...LEGS_TYPES_AIR]) : LEGS_TYPES).find(val => { return leg.legType === val.value })}
                                 name="legType"
                                 onSelect={(e) => this.selectLegType(index, e.value, e.name)}
                                 displayKey="name"
                                 className="flex-1 fs-14"
                                 label="Select"
                              /> :
                                 <Input
                                    value="Door To Door"
                                    // onChange={() => this.selectCostType(0, 1, "Door to Door")}
                                    disabled="disabled"
                                 />
                              }
                           </div>
                           <div className="wt-80 mr-10">
                              <div className="fBold fs-14 header-medium-color mb-5 ml-5 ht-20">Currency</div>
                              {/* <Input placeholder="Ceiling Price" value={leg.qbr} onChange={this.onChange.bind(this, index)} name="qbr" /> */}
                              <Dropdown
                                 items={currencyTypes}
											selectedItem={currencyTypes.find(costType => { return leg.legCostName === costType['currency_name'] })}
                                 name="currency_name"
                                 onSelect={(e) => this.selectCostType(index, e['currency_type'], e['currency_name'], e['currency_symbol'])}
                                 displayKey="currency_name"
                                 label="Select"
                                 className={Cx('flex-1 fs-14',{ 'disabled': !trip.priceInBaseCurrency})} 
                              />
                           </div>
                           <div className={Cx("mr-10", {'wt-120': !isHikal, 'wt-150': isHikal})}>
                              <div className="fBold fs-14 header-medium-color mb-5 ml-5 ht-20">TAT</div>
                              {/* <div className="wt-100p mb-30 flex"> */}
                              <div className="flex">
                                 <Input placeholder="TAT" value={leg.tatValue} onChange={this.onChange.bind(this, index)} name="tatValue" />
                                 <Dropdown
                                 items={[...TAT_UNITS]}
                                 selectedItem={TAT_UNITS.find(tatUnit => { return leg.tatUnit === tatUnit.value })}
                                 name="tatUnit"
                                 onSelect={this.onSelect.bind(this, index)}
                                 displayKey="name"
                                 className="flex-1 fs-14"
                                 label="---Select---"
                              />
                              </div>
                              {/* <Dropdown
                                                items={[...TAT_UNITS]}
                                                selectedItem={TAT_UNITS.find(tatUnit => { return leg.tatUnit === tatUnit.value })}
                                                name="tatUnit"
                                                onSelect={this.onSelect.bind(this, index)}
                                                displayKey="name"
                                                className="flex-1"
                                                label="Select unit"
                                            /> */}
                              {/* </div> */}
                              </div>
                           {/* <div className="wt-110 mr-10">
                              <div className="fBold fs-14 header-medium-color mb-5 ml-5 ht-25">Day/Hour</div>
                              <Dropdown
                                 items={[...TAT_UNITS]}
                                 selectedItem={TAT_UNITS.find(tatUnit => { return leg.tatUnit === tatUnit.value })}
                                 name="tatUnit"
                                 onSelect={this.onSelect.bind(this, index)}
                                 displayKey="name"
                                 className="flex-1 fs-14"
                                 label="---Select---"
                              />
                           </div> */}
									{rfqType === 5 && <div className="wt-140 mr-10">
										<div className="fBold fs-14 header-medium-color mb-5 ml-5 ht-20">{isHikal ? `${((rfq.rfqDetails || {}).serviceCategoryType === 1 && (rfq.rfqDetails || {}).serviceType == 4 ) ? 'Container Shipment' : 'Storage Free Days'}`: 'Container Free'}</div>
										<div className="flex">
                                 <Input placeholder="" value={leg.containerFree} onChange={this.onChange.bind(this, index)} name="containerFree" />
                                 <Dropdown
											items={[...TAT_UNITS]}
											selectedItem={TAT_UNITS.find(tatUnit => { return leg.eximTatUnit === tatUnit.value })}
											name="eximTatUnit"
											onSelect={this.onSelect.bind(this, index)}
											displayKey="name"
											className="flex-1 fs-14"
											label="---Select---"
										/>
                              </div>
									</div>}
									{/* {rfqType === 5 && <div className="wt-110 mr-10">
										<div className="fBold fs-14 header-medium-color mb-5 ml-5 ht-25">Day/Hour</div>
										<Dropdown
											items={[...TAT_UNITS]}
											selectedItem={TAT_UNITS.find(tatUnit => { return leg.eximTatUnit === tatUnit.value })}
											name="eximTatUnit"
											onSelect={this.onSelect.bind(this, index)}
											displayKey="name"
											className="flex-1 fs-14"
											label="---Select---"
										/>
									</div>} */}
                           <div className={Cx("mr-10", {
                              'wt-150': isHikal,
                              'wt-110': !isHikal
                           })}>
                              <div className="fBold fs-14 header-medium-color mb-5 ml-5 ht-20">{`Business ${isHikal? 'Volume' :'Vol'}`}</div>
                              {/* <div className="wt-100p mb-30 flex"> */}
                              <div className=""><Input placeholder="BV" value={leg.businessVolumeValue} onChange={this.onChange.bind(this, index)} name="businessVolumeValue" readOnly={isHikal? ((rfq.rfqDetails || {}).serviceCategoryType === 2 || (rfq.rfqDetails || {}).serviceType == 5) : false}/></div>
                              {/* <Dropdown
                                                items={businessVolumes}
                                                selectedItem={businessVolumes.find(businessVolumeUnit => { return leg.businessVolumeUnit === businessVolumeUnit.value })}
                                                name="businessVolumeUnit"
                                                onSelect={this.onSelect.bind(this, index)}
                                                displayKey="name"
                                                className="flex-1"
                                                label="Select UOM"
                                            /> */}
                              {/* </div> */}
                           </div>

                           <div className={Cx("wt-110 mr-10", {
                              'wt-110': !isHikal,
                              'wt-180': isHikal
                           })}>
                              <div className="fBold fs-14 header-medium-color mb-5 ml-5 ht-20">UOM</div>
                              <Dropdown
                                 items={businessVolumes}
                                 selectedItem={businessVolumes.find(businessVolumeUnit => { return leg.businessVolumeUnit === businessVolumeUnit.value })}
                                 name="businessVolumeUnit"
                                 onSelect={this.onSelect.bind(this, index)}
                                 displayKey="name"
                                 label="---Select---"
                                 className={Cx('flex-1 fs-14', { 'disabled': isHikal? ((rfq.rfqDetails || {}).serviceCategoryType === 2 || (rfq.rfqDetails || {}).serviceType == 5) : false})} 
                              />
                           </div>
                           {/* {rfqServiceType === 5 &&
                           <Fragment>
                              <div className="wt-110 mr-10">
                                 <div className="fBold fs-14 header-medium-color mb-5 ml-5 ht-20">Cargo Vol</div>
                                 <div className="">
                                    <Input placeholder="BV" value={leg.businessVolumeValue} onChange={this.onChange.bind(this, index)} name="businessVolumeValue" /></div>
                              </div>
                              <div className="wt-110 mr-10">
                                 <div className="fBold fs-14 header-medium-color mb-5 ml-5 ht-20">UOM</div>
                                 <Dropdown
                                    items={businessVolumes}
                                    selectedItem={businessVolumes.find(businessVolumeUnit => { return leg.businessVolumeUnit === businessVolumeUnit.value })}
                                    name="businessVolumeUnit"
                                    onSelect={this.onSelect.bind(this, index)}
                                    displayKey="name"
                                    className="flex-1 fs-14"
                                    label="---Select---"
                                 />
                              </div>
                           </Fragment>} */}
                           {rfqType === 2 && <div className="wt-110 mr-10">
                              <div className="fBold fs-14 header-medium-color mb-5 ml-5 ht-20">Budget</div>
                              {/* <div className="wt-100p mb-30 flex"> */}
                              <div className=""><Input placeholder="Budget" value={leg.legBudget} onChange={this.onChangeBudget.bind(this, index)} name="legBudget" /></div>
                              {/* </div> */}
                           </div>}

                           {
                           rfqType === 5 && !isHikal && 
                           <Fragment>
                              <div className="wt-110 mr-10">
                                 <div className="fBold fs-14 header-medium-color mb-5 ml-5 ht-20">Budget (INR)</div>
                                 {/* <div className="wt-100p mb-30 flex"> */}
                                 <div className=""><Input type="number" className={Cx({ 'disabled': ['USD', 'EUR'].includes(leg.legCostName) || !leg.legCostName })} placeholder="INR" readOnly={['USD', 'EUR'].includes(leg.legCostType)} value={leg.legBudgetINR && (['USD', 'EUR'].includes(leg.legCostName)) && Number(leg.legBudgetINR).toFixed(2) || leg.legBudgetINR} onChange={this.onChangeBudget.bind(this, index)} name="legBudgetINR"  onKeyDown={e => (["e", "E", "+", "-"].includes(e.key)) && e.preventDefault()}/></div>
                                 {/* </div> */}
                              </div>
                              <div className="wt-110 mr-10">
                                 <div className="fBold fs-14 header-medium-color mb-5 ml-5 ht-20">{`Budget (${secondaryCurrency})`}</div>
                                 {/* <div className="wt-100p mb-30 flex"> */}
                                 <div className="">
                                    <Input 
                                       className={Cx({ 'disabled': leg.legCostName === 'INR' || !leg.legCostName })} 
                                       placeholder={secondaryCurrency} 
                                       readOnly={leg.legCostName === 'INR'} 
                                       value={(leg.legCostName === 'INR') && leg[`legBudget${secondaryCurrency === 'EUR' ? 'Secondary' : 'USD'}`] && Number(leg[`legBudget${secondaryCurrency === 'EUR' ? 'Secondary' : 'USD'}`]).toFixed(2) || leg[`legBudget${secondaryCurrency === 'EUR' ? 'Secondary' : 'USD'}`]} 
                                       onChange={this.onChangeBudget.bind(this, index)} 
                                       name={secondaryCurrency === 'EUR' ? "legBudgetSecondary" : "legBudgetUSD"}
                                       type={'number'}
                                       onKeyDown={e => (["e", "E", "+", "-"].includes(e.key)) && e.preventDefault()}
                                    />
                                    </div>
                                 {/* </div> */}
                              </div>
                              <div className="wt-120 mr-10">
                                 <div className="fBold fs-14 header-medium-color mb-5 ht-20">Ceiling Price(INR)</div>
                                 <div className=""><Input className={Cx({ 'disabled': ['USD', 'EUR'].includes(leg.legCostName) || !leg.legCostName })} placeholder="INR" readOnly={['USD', 'EUR'].includes(leg.legCostName)} value={leg.legBudgetCPINR && (['USD', 'EUR'].includes(leg.legCostName)) && Number(leg.legBudgetCPINR).toFixed(2) || leg.legBudgetCPINR} onChange={this.onChangeBudgetCP.bind(this, index)} name="legBudgetCPINR" type="number" onKeyDown={e => (["e", "E", "+", "-"].includes(e.key)) && e.preventDefault()}/></div>
                                 {/* </div> */}
                              </div>
                              <div className="wt-120">
                                 <div className="fBold fs-14 header-medium-color mb-5 ht-20">{`Ceiling Price(${secondaryCurrency})`}</div>
                                 <div className="">
                                    <Input 
                                       className={Cx({ 'disabled': leg.legCostName === 'INR' || !leg.legCostName })} 
                                       placeholder={secondaryCurrency} 
                                       readOnly={leg.legCostName === 'INR'} 
                                       value={leg[`legBudgetCP${secondaryCurrency === 'EUR' ? 'Secondary' : 'USD'}`] && (leg.legCostName === 'INR') && Number(leg[`legBudgetCP${secondaryCurrency === 'EUR' ? 'Secondary' : 'USD'}`]).toFixed(2) || (leg[`legBudgetCP${secondaryCurrency === 'EUR' ? 'Secondary' : 'USD'}`])} 
                                       onChange={this.onChangeBudgetCP.bind(this, index)} 
                                       name={secondaryCurrency === 'EUR' ? 'legBudgetCPSecondary' : 'legBudgetCPUSD'} 
                                       type="number"
                                       onKeyDown={e => (["e", "E", "+", "-"].includes(e.key)) && e.preventDefault()}
                                    />
                                 </div>
                                 {/* </div> */}
                              </div>
                           </Fragment>
                           }

                        </div>
                        <div className="wt-100p  flex">
                           <div className={Cx("fBold fs-14 header-medium-color mb-5 ml-5", {'wt-110': !isHikal, 'wt-180': isHikal})}>Cost Heading</div>
									<div className="fBold fs-14 header-medium-color wt-80 pl-5 mr-15 ml-5">{rfqType === 5 ? "Currency" :"Cost Type"}</div>
                           {!isHikal && <div className="fBold fs-14 header-medium-color wt-120 pl-5 mr-10">Description</div>}
                           {/*<div className="fBold fs-14 header-medium-color wt-110 pl-5">RR</div>*/}
                           {/*<div className="fBold fs-14 header-medium-color wt-110 ml-5 pl-8">LPP</div>*/}
                           {rfqType === 5 && (isHikal ? true : rfqServiceType === 5) &&
                           <Fragment>
                              {<div className={Cx("fBold fs-14 header-medium-color ml-5", {'wt-110': !isHikal, 'wt-80': isHikal})}>Business Vol</div>}
                              <div className={Cx("fBold fs-14 header-medium-color ml-5",{'wt-110': !isHikal, 'wt-150': isHikal})}>UOM</div>
                           </Fragment>
                           }
                           {(rfqType === 5 && isHikal) &&
                           <Fragment>
                              <div className="fBold fs-14 header-medium-color wt-110 ml-5">LPP (INR)</div>
                              {(isHikal ? isDiffMultiLegCurrency : true) && <div className="fBold fs-14 header-medium-color wt-110 ml-5">LPP</div>}
                              <div className="fBold fs-14 header-medium-color wt-110 ml-5">LPP Date</div>
                           </Fragment>
                           }
                           {rfqType === 2 && <div className="fBold fs-14 header-medium-color wt-110 ml-5">Budget</div>}
                           {rfqType === 5 && 
                              <Fragment>
                                 <div className="fBold fs-14 header-medium-color wt-110 ml-5">Budget (INR)</div>
                                 {(isHikal ? isDiffMultiLegCurrency : true) && <div className="fBold fs-14 header-medium-color wt-110 ml-5">Budget</div>}
                              </Fragment>
                           }
                           {rfqType === 2 && <div className="fBold fs-14 header-medium-color wt-110 ml-10">CP</div>}
                           {rfqType === 5 && 
                              <Fragment>
                                 <div className="fBold fs-14 header-medium-color wt-120 ml-10">Ceiling Price(INR)</div>
                                 {(isHikal ? isDiffMultiLegCurrency : true) && <div className="fBold fs-14 header-medium-color wt-120 ml-10">Ceiling Price</div>}
                              </Fragment>
                           }
                           <div className="fBold fs-14 header-medium-color wt-110 ml-10"></div>
                        </div>
                        {
                           leg.multiModeHeadingCharges.length > 0 ? leg.multiModeHeadingCharges.map((hc, hcindex) => {

                              const hcSecondaryCurrency = (hc.headingChargesUnitName === "INR" || !hc.headingChargesUnitName) ? secondaryCurrency : hc.headingChargesUnitName;
                              return(
                              <div key={`hc_${hcindex}`} className={Cx("flex mb-10", {'ht-40': !isHikal})}>
                                 <div className={Cx("mr-10", {'wt-110': !isHikal, 'wt-180': isHikal})}>
                                    {/* <div className="wt-100p mb-30 flex"> */}
                                    {(isHikal ? hc.headingChargesValue : true) ? <div className="">
                                       <Input placeholder="Charges" readOnly={isHikal} value={hc.headingChargesValue} onChange={(e) => this.onHCChange(index, hcindex, e.target.value, e.target.name)} name="headingChargesValue" />
                                    </div> : 
                                       <Dropdown
                                       items={costHeadList}
                                       selectedItem={costHeadList.find(costHead => { return hc.headingChargesValue === costHead.name })}
                                       name="headingChargesValue"
                                       onSelect={(e) => this.onHCChange(index, hcindex, e.name, 'headingChargesValue')}
                                       displayKey="name"
                                       className="flex-1"
                                       label="Select.."
                                       /> 
                                    }
                                    {/* <Dropdown
                                                        items={pricingBasis}
                                                        selectedItem={pricingBasis.find(pricingBasis => { return hc.headingChargesUnit === pricingBasis.value })}
                                                        name="headingChargesUnit"
                                                        onSelect={(e) => this.onHCChange(index, hcindex, e.value, 'headingChargesUnit')}
                                                        displayKey="name"
                                                        className="flex-1"
                                                        label="Select unit"
                                                    /> */}

                                    {/* </div> */}
                                    {rfqType === 5 && isHikal && baseCurrencySubmitted && !hc.headingChargesValue && <span className ="error-color fs-14 fSemibold op-7 mt-10">Please Select the Cost</span> }
                                 </div>
                                 <div className="wt-80 mr-10">
                                    <Dropdown
                                       items={currencyTypes}
                                       selectedItem={currencyTypes.find(pricingBasis => { return hc.headingChargesUnit === pricingBasis['currency_type'] })}
                                       name="headingChargesUnit"
                                       onSelect={(e) => {
                                          if(HIKAL.includes(getUser().companyId)) {
                                             this.setState({
                                                isConfirmPopUp: true,
                                                legCurrencyDetails: {
                                                   index,
                                                   hcindex,
                                                   currency: e
                                                }
                                             })
                                          } else {
                                             this.onHCChange(index, hcindex, e['currency_type'], 'headingChargesUnit', e)
                                          }
                                       }}
                                       displayKey="currency_name"
                                       label="Select"
                                       className={Cx("flex-1 fs-14", { 'disabled': !trip.priceInBaseCurrency})}
                                    />
                                    {rfqType === 5 && isHikal && baseCurrencySubmitted && !hc.headingChargesUnit && <span className ="error-color fs-14 fSemibold op-7 mt-10">Please Select the Currency</span> }
                                 </div>

                                 {(!isHikal) && <div className="wt-120 mr-10">
                                    <div className="wt-100p mr-20"><Input placeholder="Desc" value={hc.headingChargesDescription}
                                       onChange={(e) => this.onHCChange(index, hcindex, e.target.value, e.target.name)} name="headingChargesDescription" /></div>
                                 </div>}

                                 {/*<div className="wt-110 mr-10">

                                    <div className="wt-100p mr-20 "><Input type="number" placeholder="RR" value={hc.headingChargesMr} onChange={(e) => this.onHCChange(index, hcindex, e.target.value, e.target.name)} name="headingChargesMr" /></div>
                                 </div>
                                 <div className="wt-110 mr-10">

                                    <div className="wt-100p mr-20"><Input type="number" placeholder="LPP" value={hc.headingChargesLpp} onChange={(e) => this.onHCChange(index, hcindex, e.target.value, e.target.name)} name="headingChargesLpp" /></div>
                                 </div>*/}
                                 {rfqType === 5 && (isHikal ? true : rfqServiceType === 5) && 
                                    <Fragment>
                                       {<div className={Cx("mr-10", {'wt-110': !isHikal, 'wt-80': isHikal})}>
                                          <div className="wt-100p mr-20"><Input type="number" placeholder="Business Vol" value={hc.headingChargesBusinessVolumeValue} onChange={(e) => this.onHCChange(index, hcindex, e.target.value, e.target.name)} name="headingChargesBusinessVolumeValue" /></div>
                                       </div>}
                                       <div className={Cx("mr-10", {'wt-110': !isHikal, 'wt-150': isHikal})}>
                                       <Dropdown
                                          items={businessVolumes}
                                          selectedItem={businessVolumes.find(businessVolumeUnit => { return hc.headingChargesBusinessVolumeUnit === businessVolumeUnit.value })}
                                          name="headingChargesBusinessVolumeUnit"
                                          onSelect={(e) => this.onHCChange(index, hcindex, e['value'], 'headingChargesBusinessVolumeUnit', e)}
                                          displayKey="name"
                                          className="flex-1 fs-14"
                                          label="Select"
                                       />
                                       </div>
                                    </Fragment>
                                 }
                                 {(rfqType === 5 && isHikal) && 
                                    <Fragment>
                                       <div className="wt-110 mr-10">
                                          <div className="wt-100p mr-20">
                                             <Input 
                                                type="number" 
                                                placeholder="" 
                                                value={hc.headingChargesLpp_inr && ([2, 3].includes(hc.headingChargesUnit)) && Number(hc.headingChargesLpp_inr).toFixed(2) || hc.headingChargesLpp_inr }  
                                                onChange={(e) => this.onHCChange(index, hcindex, e.target.value, e.target.name)} 
                                                name="headingChargesLPP" 
                                                disabled={true}
                                             />
                                          </div>
                                       </div>
                                       {(isHikal ? isDiffMultiLegCurrency : true) && <div className="wt-110 mr-10">
                                          <div className="wt-100p mr-20">
                                             <Input 
                                                type="number" 
                                                placeholder="" 
                                                value={hc[`headingChargesLpp_${hcSecondaryCurrency === 'EUR' ? 'secondary' : 'usd'}`] && (hc.headingChargesUnit === 1) && Number(hc[`headingChargesLpp_${hcSecondaryCurrency === 'EUR' ? 'secondary' : 'usd'}`]).toFixed(2) || (hc[`headingChargesLpp_${hcSecondaryCurrency === 'EUR' ? 'secondary' : 'usd'}`]) } 
                                                onChange={(e) => this.onHCChange(index, hcindex, e.target.value, e.target.name)} 
                                                name="headingChargesLPP" 
                                                disabled={true}
                                             />
                                          </div>
                                       </div>}
                                       <div className="wt-110 mr-10">
                                          <div className="wt-100p mr-20">
                                             <Input 
                                                placeholder="" 
                                                value={hc.headingChargesLPPDate} 
                                                onChange={(e) => this.onHCChange(index, hcindex, e.target.value, e.target.name)} 
                                                name="headingChargesLPPDate" 
                                                disabled={true}
                                             />
                                          </div>
                                       </div>
                                    </Fragment>
                                 }
                                 {rfqType === 2 && <div className="wt-110 mr-10">
                                    <div className="wt-100p mr-20"><Input type="number" placeholder="Budget" value={hc.headingChargesBudget} onChange={(e) => this.onHCChange(index, hcindex, e.target.value, e.target.name)} name="headingChargesBudget" onKeyDown={e => (["e", "E", "+", "-"].includes(e.key)) && e.preventDefault()}/></div>
                                 </div>}
                                 {rfqType === 5 && 
                                 <Fragment>
                                    <div className="wt-110 mr-10">
                                       <div className="wt-100p mr-20"><Input type="number" className={Cx({ 'disabled': [2, 3].includes(hc.headingChargesUnit) || !hc.headingChargesUnit })} readOnly={[2, 3].includes(hc.headingChargesUnit)} placeholder="INR" value={hc.headingChargesBudget_inr && ([2, 3].includes(hc.headingChargesUnit)) && Number(hc.headingChargesBudget_inr).toFixed(2) || hc.headingChargesBudget_inr } onChange={(e) => this.onHCChange(index, hcindex, e.target.value, e.target.name)} name="headingChargesBudget_inr" onKeyDown={e => (["e", "E", "+", "-"].includes(e.key)) && e.preventDefault()}/></div>
                                    </div>
                                    {(isHikal ? isDiffMultiLegCurrency : true) && <div className="wt-110 mr-10">
                                       <div className="wt-100p mr-20">
                                          <Input 
                                             type="number" 
                                             className={Cx({ 'disabled': hc.headingChargesUnit === 1 || !hc.headingChargesUnit })} 
                                             readOnly={hc.headingChargesUnit === 1} 
                                             placeholder={'10' || hcSecondaryCurrency} 
                                             value={hc[`headingChargesBudget_${hcSecondaryCurrency === 'EUR' ? 'secondary' : 'usd'}`] && (hc.headingChargesUnit === 1) && Number(hc[`headingChargesBudget_${hcSecondaryCurrency === 'EUR' ? 'secondary' : 'usd'}`]).toFixed(2) || (hc[`headingChargesBudget_${hcSecondaryCurrency === 'EUR' ? 'secondary' : 'usd'}`]) } 
                                             onChange={(e) => this.onHCChange(index, hcindex, e.target.value, e.target.name)} 
                                             name={hcSecondaryCurrency === 'EUR' ? "headingChargesBudget_secondary" : "headingChargesBudget_usd"} 
                                             onKeyDown={e => (["e", "E", "+", "-"].includes(e.key)) && e.preventDefault()}
                                          />
                                       </div>
                                    </div>}
                                 </Fragment>
                                 }
                                 {rfqType === 2 && <div className="wt-110 mr-10">

                                    <div className="wt-100p mr-20"><Input type="number" placeholder="CP" value={hc.headingChargesCp} onChange={(e) => this.onHCChange(index, hcindex, e.target.value, e.target.name)} name="headingChargesCp" onKeyDown={e => (["e", "E", "+", "-"].includes(e.key)) && e.preventDefault()}/></div>
                                 </div>}
                                 {rfqType === 5 &&
                                 <Fragment>
                                    <div className="wt-120 mr-10">
                                       <div className="wt-100p mr-20"><Input type="number" className={Cx({ 'disabled': [2,3].includes(hc.headingChargesUnit) || !hc.headingChargesUnit })} placeholder="INR" readOnly={[2,3].includes(hc.headingChargesUnit)} value={hc.headingChargesCp_inr && ([2,3].includes(hc.headingChargesUnit)) && Number(hc.headingChargesCp_inr).toFixed(2) || hc.headingChargesCp_inr } onChange={(e) => this.onHCChange(index, hcindex, e.target.value, e.target.name)} name="headingChargesCp_inr" onKeyDown={e => (["e", "E", "+", "-"].includes(e.key)) && e.preventDefault()}/></div>
                                    </div>
                                    {(isHikal ? isDiffMultiLegCurrency : true) && <div className="wt-120 mr-10">
                                       <div className="wt-100p mr-20">
                                          <Input 
                                             type="number" 
                                             className={Cx({ 'disabled': hc.headingChargesUnit === 1 || !hc.headingChargesUnit })} 
                                             placeholder={'12' || hcSecondaryCurrency} 
                                             readOnly={hc.headingChargesUnit === 1} 
                                             value={hc[`headingChargesCp_${hcSecondaryCurrency === 'EUR' ? 'secondary' : 'usd'}`] && (hc.headingChargesUnit === 1) && Number(hc[`headingChargesCp_${hcSecondaryCurrency === 'EUR' ? 'secondary' : 'usd'}`]).toFixed(2) || (hc[`headingChargesCp_${hcSecondaryCurrency === 'EUR' ? 'secondary' : 'usd'}`]) } 
                                             onChange={(e) => this.onHCChange(index, hcindex, e.target.value, e.target.name)} 
                                             name={hcSecondaryCurrency === 'EUR' ? 'headingChargesCp_secondary' : 'headingChargesCp_usd'} 
                                          />
                                       </div>
                                    </div>}
                                 </Fragment>}
                                 <div className="wt-110 flex mr-10">
                                    {
                                       leg.multiModeHeadingCharges.length > 1 && (isHikal ? hc.headingChargesValue !== 'Base Freight' : true) ? <div className="flex flex-middle flex-center wt-25 ht-25 br-20 border-none br-50p mr-5">
                                          <CloseIcon onClick={() => this.removeMultiModeHeadingCharge(index, hcindex)} className="wt-28 white-color ht-28 pa curP" />
                                       </div> : ''
                                    }
                                    {
                                       hcindex == leg.multiModeHeadingCharges.length - 1 ? <div className="flex flex-middle flex-center bg-theme wt-25 ht-25 br-20 border-none br-50p mr-5">
                                          <PlusIcon onClick={() => this.addNewHeadingCharge(index)} className="wt-15 ht-15" />
                                       </div> : ''
                                    }
                                 </div>
                              </div>)
                           }) : this.addNewHeadingCharge(index)
                        }
                     </div>
                  )
               })
            }
            {
               // this.props && this.props.trip && this.props.trip.movementTypeName =="LegsWise" &&
               multiLevelMovementType === 2 &&
               <div className="flex flex-middle curP mt-30 wt-max-content" onClick={this.addLeg}>
                  <div className="flex flex-middle flex-center bg-theme wt-25 ht-25 br-20 border-none br-50p mr-5">
                     <PlusIcon className="wt-15 ht-15" />
                  </div>
                  <div className="fSemibold fs-16 fBold header-dark-color">Add Leg</div>
               </div>
            }
            {this.state.isConfirmPopUp &&
               <ConfirmationPopup 
               text={"Are you sure to change the currency type ?"}
               onCancel={() => this.setState({ isConfirmPopUp: false, legCurrencyDetails: ''})}
               onConfirm={() => this.onHCChange(legCurrencyDetails.index, legCurrencyDetails.hcindex, legCurrencyDetails.currency['currency_type'], 'headingChargesUnit', legCurrencyDetails.currency)}
            />
            }

         </React.Fragment>

      )
   }
}

export default connect(null, null)(LegDetails);
